export default "__VITE_ASSET__6a8260fe__"